import script from "./itemV3Height.vue?vue&type=script&setup=true&lang=ts"
export * from "./itemV3Height.vue?vue&type=script&setup=true&lang=ts"

import "./itemV3Height.vue?vue&type=style&index=0&id=6cd31a40&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6cd31a40"]])

export default __exports__